import { MutableRefObject } from 'react';
import { Project, StructuredProject } from '@mb/lib';
import { IntlShape } from 'react-intl';
import { RecommendResponseObject } from './recommendStrip';
import { ProductSearchMaterial } from '../../../pages/ProductSearch/types';
export interface DataModalProps {
  onPdpClose: (event: any, reason?: string) => void;
  itemListId?: string;
  itemListName?: string;
  clickedProductGridIndex?: number;
  clickedProductRequestId?: string;
  cartItemsIds?: string[];
  intl: IntlShape;
  projects?: Project[];
  currentProjectData: StructuredProject;
  shouldShowContactButton: boolean;
  structuredProjects: StructuredProject[];
  isAbEnabled?: boolean;
  userLang: 'en' | 'es' | 'de' | 'fr' | 'it';
  trackingData?: {
    gtm?: unknown;
  };
  learnMoreNewTab?: boolean;
  wasModalTriggered: boolean;
  onModalTriggered: (value: boolean) => void;
  onContactRepClick: (ref: MutableRefObject<HTMLDivElement | null>) => void;
  dataLayerAnalytics?: {
    listId: string;
    listName: string;
    eventLocation: string;
  };
  onVariationClick?: (material: ProductSearchMaterial) => void;
  onRecStripLoad?: (payload: RecommendResponseObject[]) => void;
}

export enum ResponseStatusEnum {
  FAILED = 'failed',
  SUCCESS = 'success',
}

export enum SnackbarStatusEnum {
  DANGER = 'danger',
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
}
